const Footer = () => {
  return (
    <footer className="w-full bg-[#222222] mt-auto">
      <div className="text-[#71717a] px-4 sm:px-[60px] md:pt-12 md:border-t md:border-gray-700 py-[60px] sm:py-8 md:py-12 lg:py-[60px]">
        <p
          className="company-name mb-5 md:text-center md:text-lg"
          aria-label="(주)브이드림"
        >
          (주)브이드림
        </p>

        <div className="info__list w-full mb-4 flex justify-start flex-wrap md:justify-center">
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="대표이사 : 김민지"
          >
            대표이사 : 김민지
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="사업자 등록번호 : 186-86-00972"
          >
            사업자 등록번호 : 186-86-00972
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="대표번호 : 1644-8619"
          >
            대표번호 : 1644-8619
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="대표메일(일반) : contact@vdream.co.kr"
          >
            대표메일(일반) : contact@vdream.co.kr
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="인사문의(인사/회계/증명서) : hr@vdream.co.kr"
          >
            인사문의(인사/회계/증명서) : hr@vdream.co.kr
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="FAX : 051-711-8573"
          >
            FAX : 051-711-8573
          </p>
        </div>

        <div className="info__list w-full mb-4 flex justify-start flex-wrap md:justify-center">
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="직업정보제공사업 신고번호 : 부산지방고용노동청 제2023-4호"
          >
            직업정보제공사업 신고번호 : 부산지방고용노동청 제2023-4호
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="서울청 제 2023-13호"
          >
            서울청 제 2023-13호
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="서울 오피스 : 서울 특별시 서초구 반포대로 18길 36, 서초센트럴 PARK 오피스동 7층"
          >
            서울 오피스 : 서울 특별시 서초구 반포대로 18길 36, 서초센트럴 PARK 오피스동 7층
          </p>
          <p
            className="text-sm md:text-[15px] leading-[130%] after:content-['|'] after:inline-block after:mx-2 last:after:content-none"
            aria-label="부산 오피스 : 부산광역시 동구 중앙대로 319, YMCA빌딩 1614호"
          >
            부산 오피스 : 부산광역시 동구 중앙대로 319, YMCA빌딩 1614호
          </p>
        </div>

        <div className="info__list w-full mb-0 flex justify-start flex-wrap md:justify-center">
          <p
            className="text-sm md:text-[15px] leading-[130%]"
            aria-label="© VDREAM"
          >
            © VDREAM
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
